// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Twc5Q","option":"styles_option__1Dtly","active":"styles_active__nqmWb"};